module.exports = __webpack_public_path__ + "static/media/Female Avatar_1585002071501.87e070a3.png";